import { IPromise, IScope } from 'angular'
import { $q } from '../../../ng-compat/imports'
import {
  LSPayEcomApiResponse,
  LSPayEcomRefundModalOptions,
} from './helpers/types'

/**
 * Controller class for the LSPayEcomRefund
 *
 * @class LSPayEcomRefundModalController
 */

export class LSPayEcomRefundModalController {
  public readonly close: () => void
  public readonly amount: number
  public readonly originalSaleId: string
  public readonly registerId: string
  public readonly registerSalePaymentId: string
  private readonly internalClose: (val: IPromise<LSPayEcomApiResponse>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<LSPayEcomApiResponse>) => void,
    public readonly options: LSPayEcomRefundModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'
    this.internalClose = close
    this.close = () => this.internalClose($q.reject())
    this.amount = options.amount
    this.originalSaleId = options.originalSaleId
    this.registerId = options.registerId
    this.registerSalePaymentId = options.registerSalePaymentId

    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
